import React from "react";
import { useGoogleLogin } from "@react-oauth/google";
import { ReactComponent as GoogleIcon } from "../../../assets/svg/google-login.svg";
// import GoogleIcon from "../../../assets/svg/btn_google_signin_dark_normal_web.png";
//btn_google_signin_light_pressed_web
//btn_google_signin_light_normal_web
//btn_google_signin_light_normal_web@2x

import { toast } from "react-toastify";

const GmailLogin = (props) => {
    const login = useGoogleLogin({
        flow: "auth-code",
        scope: "https://www.googleapis.com/auth/userinfo.email",
        onSuccess: (CodeResponse) => {
            if (CodeResponse.code) {
                let param = {};
                param["auth_code"] = CodeResponse.code;
                param["platform"] = "google";
                param["redirect_url"] = window.location.origin;
                // param["scope"]="email";
                props.googleLogin(param);
            }
        },
        onError: (errResponse) => {
            console.log("first", errResponse);
            toast.error("Error in authorizing.Please try again");
        },
    });

    return (
        <>
            <span className="icon-wrap" onClick={login}>
                <GoogleIcon title="Login with Google" />
                <span className="fix__align auth_text">{props.authType} with Google</span>

                {/* <img src={GoogleIcon} /> */}
            </span>
        </>
    );
};
export default GmailLogin;
